import { observable, action, makeObservable } from 'mobx'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

type ModalOptions = 'fullScreen'

class ModalStore {
  content: JSX.Element = null
  show: boolean = false
  fullScreen: boolean = false
  targetElement: HTMLElement = null

  constructor() {
    makeObservable(this, {
      content: observable,
      show: observable,
      fullScreen: observable,
      targetElement: observable,
      set: action,
      toggle: action
    })
  }

  set = (content: JSX.Element, option?: ModalOptions): void => {
    switch (option) {
      case 'fullScreen':
        this.fullScreen = true
        break

      default:
        this.fullScreen = false
        break
    }
    this.content = content
  }

  toggle = (): void => {
    this.show = !this.show

    this.show ? disableBodyScroll(this.targetElement) : enableBodyScroll(this.targetElement)
  }
}

export const modalStore = new ModalStore()
